import * as yup from "yup";

import { PrimaryLanguages, SoundEffects } from "../../types";
import phoneSchema from "./phone";

const SOUND_EFFECTS = Object.values(SoundEffects);
const PRIMARY_LANGUAGES = Object.values(PrimaryLanguages);

export default yup.object({
  legacy_guid: yup.string(),
  legacy_uid: yup.string(),
  group_id: yup.number(),
  chat: yup.object({
    concurrent_limit: yup.number().min(1).max(6),
    agent_to_agent_enabled: yup.boolean(),
  }),
  crm: yup.object({
    hide_customer_contact_info_enabled: yup.boolean(),
  }),
  email: yup.object({
    pull_emails_from_queue_enabled: yup.boolean(),
    delete_pending_emails_enabled: yup.boolean(),
    default_to_channel_from_address_enabled: yup.boolean(),
    default_from_address: yup.string(),
    signature: yup.string().max(2000),
    default_signature: yup.string(),
  }),
  smtp: yup.object({
    server_id: yup.string(),
    override_enabled: yup.boolean(),
  }),
  interactions: yup.object({
    offer_timeout: yup.number().min(1),
    offer_rejection_enabled: yup.boolean(),
    primary_language: yup.string().oneOf(PRIMARY_LANGUAGES),
  }),
  external_crm: yup.object({
    username: yup.string(),
    password: yup.string(),
    // @TODO: Field "configuration" needs to be further specified to be worth including.
    // configuration: yup.object({}),
    salesforce_enabled: yup.boolean(),
  }),
  supervisor: yup.object({
    enabled: yup.boolean(),
    call_monitoring_enabled: yup.boolean(),
    report_restriction_enabled: yup.boolean(),
  }),
  phone: phoneSchema,
  ui: yup.object({
    modify_queue_assignments_enabled: yup.boolean(),
    options_menu_enabled: yup.boolean(),
    my_recordings_enabled: yup.boolean(),
    click_to_dial_enabled: yup.boolean(),
    notification_sound: yup.string().oneOf(SOUND_EFFECTS),
    chat_message_browser_notification_enabled: yup.boolean(),
    chat_message_sound: yup.string().oneOf(SOUND_EFFECTS),
    status_code_list_enabled: yup.boolean(),
    display_customer_cli_enabled: yup.boolean(),
  }),
});
